//  以下鉴权接口 失败时不提示
export const noAuthUrls = [
  '/gp/logoutAtk',
  '/message/updateUserMessageToken',
  '/message/getUserCount',
  '/remain/activation/canJoin',
  '/remain/activation/info',
  '/rebate/totalAmountAvailable'
];
